import feedbackConfig from './resources/feedback.json';

export interface FeedbackOptions {
    feedbackText: string;
    feedbackInputType: string;
    eventName: string;
    feedbackOptions?: string[];
}

export const feedbackOptions: Record<string, FeedbackOptions> = {
    experience: {
        feedbackText: feedbackConfig.providence.feedbackText,
        feedbackInputType: 'Text',
        eventName: 'Feedback Intent Utterances',
    },
    options: {
        // eventName should be updated
        feedbackText: feedbackConfig.providence.whatLookingForHelp,
        feedbackInputType: 'Options',
        eventName: 'Feedback Intent Utterances',
        feedbackOptions: feedbackConfig.providence.whatLookingForHelpOptions,
    },
    stars: {
        feedbackText: feedbackConfig.providence.starsText,
        feedbackInputType: 'Text',
        eventName: 'Feedback - Rating Selected',
    },
    helpful: {
        feedbackText: feedbackConfig.providence.helpfulText,
        feedbackInputType: 'Options',
        eventName: 'Feedback - Helpful Prompted',
        feedbackOptions: ['Yes', 'No'],
    },
    thankyou: {
        feedbackText: feedbackConfig.providence.thankYou,
        feedbackInputType: 'Text',
        eventName: 'Feedback Intent Utterances',
    },
};

export const closeFeedbackData = {
    feedback: true,
    feedbackType: 'Feedback',
    feedbackResponseType: ['stars', 'options', 'experience', 'thankyou'],
    labelText: '',
};
